import React, { Fragment, useRef, useState } from 'react';
import { Alert } from '@bechtel/gds';
import { usePlanningPermissions } from './hooks';
import { CrewMemberExpiredMilestoneStats, ProjectWeek } from '@bechtel/types';
import { PlanningTab } from './types';
import { useToastsDispatch } from '@bechtel/gds';
import {
  useModulePermission,
  useSessionStorage,
  CacheKeys,
  ErrorBoundary,
  PlanningContext,
  TOAST_ID_WORK_PACKAGE,
  TOAST_ID_SELECT_FOREMAN,
} from '@bechtel/client-common';
import { PlanningListView } from '~/list';
import { PlanningViewDetail as PlanningDetail } from '~/detail';
import { Trans } from '@lingui/macro';

const PlanningView = () => {
  const { canViewPlanningModule } = useModulePermission();
  const expiredMilestoneStats = useRef<CrewMemberExpiredMilestoneStats>({ id: '0', numExpiredMilestones: 0 });
  const [selectedProjectWeek, setSelectedProjectWeek] = useState<ProjectWeek>();
  const [isListCollapsed, setIsListCollapsed] = useState(false);
  const [selectedTab, setSelectedTab] = useSessionStorage<PlanningTab>(CacheKeys.PlanningSelectedTab, PlanningTab.PLAN);
  const { canViewPlan } = usePlanningPermissions();
  const dispatchToast = useToastsDispatch();
  if (!canViewPlanningModule) {
    return (
      <Alert>
        <Trans>Sorry, Planning module is not activated for this project.</Trans>
      </Alert>
    );
  }
  if (!canViewPlan)
    return (
      <Alert>
        <Trans>Sorry, you do not have permission to view plan</Trans>
      </Alert>
    );

  const handleToggleCollapse = () => {
    setIsListCollapsed((state) => !state);
  };

  const handleTabChange = (tab: PlanningTab) => {
    if (tab != PlanningTab.PLAN) {
      dispatchToast({ type: 'REMOVE_TOAST', payload: { id: TOAST_ID_SELECT_FOREMAN } });
      dispatchToast({ type: 'REMOVE_TOAST', payload: { id: TOAST_ID_WORK_PACKAGE } });
    }
    setSelectedTab(tab);
  };

  return (
    <Fragment>
      <ErrorBoundary>
        <PlanningContext>
          <PlanningDetail
            expiredMilestoneStats={expiredMilestoneStats}
            isListCollapsed={isListCollapsed}
            onTabChange={handleTabChange}
            selectedProjectWeek={selectedProjectWeek}
            selectedTab={selectedTab}
            data-testid="planning-details"
          />
          <PlanningListView
            expiredMilestoneStats={expiredMilestoneStats}
            isListCollapsed={isListCollapsed}
            onToggleCollapse={handleToggleCollapse}
            selectedTab={selectedTab}
            onSelectWeek={(projectWeek) => setSelectedProjectWeek(projectWeek)}
            data-testid="planning-list"
          />
        </PlanningContext>
      </ErrorBoundary>
    </Fragment>
  );
};

export default PlanningView;
